export const CREATE_LINE_GROUP = 'CREATE_LINE_GROUP';
export const DELETE_LINE_GROUP = 'DELETE_LINE_GROUP';
export const UPDATE_LINE_GROUP = 'UPDATE_LINE_GROUP';
export const REORDER_LINE_GROUP = 'REORDER_LINE_GROUP';
export const ADD_LINE_TO_LINE_GROUP = 'ADD_LINE_TO_LINE_GROUP';
export const REMOVE_LINE_FROM_LINE_GROUP = 'REMOVE_LINE_FROM_LINE_GROUP';
export const SELECT_LINE_GROUP_LINE = 'SELECT_LINE_GROUP_LINE';

export function createLineGroup(lines) {
  return (dispatch, getState) => {
    const id = Math.max(0, ...getState().song.linegroups.allIds) + 1;
    return dispatch({
      type: CREATE_LINE_GROUP,
      obj: { id, lines },
    });
  };
}

export function deleteLineGroup(id) {
  return { type: DELETE_LINE_GROUP, id };
}

export function updateLineGroup(obj) {
  return { type: UPDATE_LINE_GROUP, obj };
}

export function reorderLineGroup(lines) {
  return { type: REORDER_LINE_GROUP, lines };
}

export function addLineToLineGroup(lineGroupId, lineId, index) {
  return {
    type: ADD_LINE_TO_LINE_GROUP,
    id: lineGroupId,
    lineId,
    index,
  };
}

export function removeLineFromLineGroup(lineGroupId, index) {
  return {
    type: REMOVE_LINE_FROM_LINE_GROUP,
    id: lineGroupId,
    index,
  };
}



// WEBPACK FOOTER //
// ./src/actions/linegroups.js